module.exports = __webpack_public_path__ + "img/map_Z3.6.A.03.84cd26bd.svg";